import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useIsMobile, { useIsSmallMobile } from '../hooks/useIsMobile';

const Footer = () => {
  const isMobile = useIsMobile();
  const isSmall = useIsSmallMobile();
  const S = makeS(isMobile, isSmall);
  const { i18n } = useTranslation();
  const hi = i18n.language === 'hi';

  return (
    <footer style={S.footer}>
      {/* Top ornament */}
      <div style={S.topOrnament}>
        <div style={S.ornLine}/>
        <span style={S.ornDiamond}>◆</span>
        <div style={S.ornLine}/>
      </div>

      <div style={S.container}>
        {/* Brand column */}
        <div style={S.brandCol}>
          <div style={S.logoText}>
            <span style={S.logoGlitz}>GLITZ & GLAM</span>
            <span style={S.logoBy}>by <em style={S.logoJyoti}>Jyoti ♥</em></span>
          </div>
          <p style={S.tagline}>
            {hi ? 'हर महिला के लिए प्रीमियम ज्वेलरी' : 'Premium artificial jewelry & fashion for every woman'}
          </p>
          <div style={S.socials}>
            {[
              {
                label: 'Instagram',
                href: 'https://instagram.com/glitz_and_glam_by_jyoti',
                icon: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <defs>
                      <radialGradient id="ig-footer" cx="30%" cy="107%" r="150%">
                        <stop offset="0%" stopColor="#fdf497"/>
                        <stop offset="45%" stopColor="#fd5949"/>
                        <stop offset="90%" stopColor="#285AEB"/>
                      </radialGradient>
                    </defs>
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="url(#ig-footer)"/>
                    <circle cx="12" cy="12" r="4.5" stroke="white" strokeWidth="1.5" fill="none"/>
                    <circle cx="17.5" cy="6.5" r="1" fill="white"/>
                  </svg>
                )
              },
              {
                label: 'WhatsApp',
                href: 'https://wa.me/919999999999',
                icon: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                )
              },
              {
                label: 'Facebook',
                href: '#',
                icon: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                )
              },
            ].map(s => (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer" style={S.socialBtn} title={s.label}>
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div style={S.col}>
          <h4 style={S.colTitle}>{hi ? 'त्वरित लिंक' : 'Quick Links'}</h4>
          {[
            { to: '/', label: hi ? 'होम' : 'Home' },
            { to: '/shop', label: hi ? 'शॉप' : 'Shop' },
            { to: '/blogs', label: hi ? 'ब्लॉग' : 'Blogs' },
            { to: '/shop-by-video', label: hi ? 'वीडियो शॉप' : 'Shop by Video' },
            { to: '/account', label: hi ? 'मेरा खाता' : 'My Account' },
            { to: '/wishlist', label: hi ? 'विशलिस्ट' : 'Wishlist' },
          ].map(l => <Link key={l.to} to={l.to} style={S.footLink}>{l.label}</Link>)}
        </div>

        {/* Categories */}
        <div style={S.col}>
          <h4 style={S.colTitle}>{hi ? 'श्रेणियाँ' : 'Categories'}</h4>
          {[
            { to: '/shop?category=jewelry', label: hi ? 'कृत्रिम गहने' : 'Artificial Jewelry' },
            { to: '/shop?category=bangles', label: hi ? 'चूड़ियाँ' : 'Bangles' },
            { to: '/shop?category=sarees', label: hi ? 'साड़ी' : 'Sarees' },
            { to: '/shop?category=hair-accessories', label: hi ? 'हेयर एक्सेसरीज़' : 'Hair Accessories' },
            { to: '/shop?category=bags', label: hi ? 'बैग्स' : 'Bags' },
            { to: '/shop?category=garments', label: hi ? 'परिधान' : 'Garments' },
          ].map(l => <Link key={l.to} to={l.to} style={S.footLink}>{l.label}</Link>)}
        </div>

        {/* Info */}
        <div style={S.col}>
          <h4 style={S.colTitle}>{hi ? 'जानकारी' : 'Information'}</h4>
          {[
            { to: '/pages/about', label: hi ? 'हमारे बारे में' : 'About Us' },
            { to: '/pages/shipping', label: hi ? 'शिपिंग नीति' : 'Shipping Policy' },
            { to: '/pages/returns', label: hi ? 'वापसी नीति' : 'Return Policy' },
            { to: '/pages/privacy', label: hi ? 'गोपनीयता नीति' : 'Privacy Policy' },
            { to: '/pages/terms', label: hi ? 'नियम और शर्तें' : 'Terms & Conditions' },
          ].map(l => <Link key={l.to} to={l.to} style={S.footLink}>{l.label}</Link>)}
        </div>

        {/* Contact */}
        <div style={S.col}>
          <h4 style={S.colTitle}>{hi ? 'संपर्क' : 'Contact Us'}</h4>
          <div style={S.contactItem}>
            <span style={S.contactIcon}>📧</span>
            <span style={S.contactText}>info@glitzandglambyjyoti.com</span>
          </div>
          <div style={S.contactItem}>
            <span style={S.contactIcon}>📍</span>
            <span style={S.contactText}>India</span>
          </div>
          <div style={S.contactItem}>
            <span style={S.contactIcon}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <defs><radialGradient id="ig-contact" cx="30%" cy="107%" r="150%"><stop offset="0%" stopColor="#fdf497"/><stop offset="45%" stopColor="#fd5949"/><stop offset="90%" stopColor="#285AEB"/></radialGradient></defs>
                <rect x="2" y="2" width="20" height="20" rx="5" fill="url(#ig-contact)"/>
                <circle cx="12" cy="12" r="4.5" stroke="white" strokeWidth="1.5" fill="none"/>
                <circle cx="17.5" cy="6.5" r="1" fill="white"/>
              </svg>
            </span>
            <a href="https://instagram.com/glitz_and_glam_by_jyoti" target="_blank" rel="noreferrer" style={{ color: '#c9a84c', fontSize: 13 }}>@glitz_and_glam_by_jyoti</a>
          </div>
          <div style={{ marginTop: 16 }}>
            <div style={S.trustBadge}>✅ {hi ? 'सुरक्षित भुगतान' : 'Secure Payment'}</div>
            <div style={S.trustBadge}>🚚 {hi ? 'पूरे भारत में डिलीवरी' : 'Pan India Delivery'}</div>
            <div style={S.trustBadge}>↩️ {hi ? '7 दिन वापसी' : '7 Day Returns'}</div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={S.bottom}>
        <div style={S.bottomInner}>
          <span style={S.copyright}>
            © 2026 Glitz & Glam by Jyoti. {hi ? 'सर्वाधिकार सुरक्षित।' : 'All rights reserved.'}
          </span>
          <div style={S.payments}>
            {['VISA', 'MC', 'UPI', 'RZP', 'COD'].map(p => (
              <span key={p} style={S.payBadge}>{p}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

const makeS = (isMobile, isSmall) => ({
  footer: { background: '#04020a', borderTop: '1px solid rgba(201,168,76,0.1)', position: 'relative', zIndex: 5 },
  topOrnament: { display: 'flex', alignItems: 'center', padding: '0 40px', opacity: 0.4 },
  ornLine: { flex: 1, height: 1, background: 'linear-gradient(90deg, transparent, rgba(201,168,76,0.6), transparent)' },
  ornDiamond: { color: '#c9a84c', fontSize: 10, margin: '0 16px', padding: '12px 0' },
  container: { maxWidth: 1280, margin: '0 auto', padding: isMobile ? '28px 14px 20px' : '48px 32px 32px', display: 'grid', gridTemplateColumns: isSmall ? '1fr' : isMobile ? 'repeat(2,1fr)' : 'repeat(auto-fit, minmax(200px, 1fr))', gap: isMobile ? 20 : 40 },
  brandCol: {},
  logoText: { marginBottom: 12 },
  logoGlitz: { display: 'block', color: '#c9a84c', fontFamily: 'Georgia,serif', fontSize: 20, fontWeight: 700, letterSpacing: 2 },
  logoBy: { display: 'block', color: 'rgba(201,168,76,0.4)', fontFamily: 'Georgia,serif', fontSize: 12, letterSpacing: 3, marginTop: 2 },
  logoJyoti: { color: '#f0c8d8', fontStyle: 'italic', fontWeight: 700 },
  tagline: { color: '#555568', fontSize: 13, lineHeight: 1.6, marginBottom: 20, fontFamily: 'system-ui' },
  socials: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  socialBtn: { width: 36, height: 36, background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', textDecoration: 'none', transition: 'all 0.2s' },
  col: {},
  colTitle: { color: '#c9a84c', fontSize: 11, fontFamily: 'system-ui', letterSpacing: 3, textTransform: 'uppercase', fontWeight: 600, marginBottom: 16 },
  footLink: { display: 'block', color: '#555568', fontSize: 13, fontFamily: 'system-ui', padding: '4px 0', textDecoration: 'none', transition: 'color 0.2s', marginBottom: 2 },
  contactItem: { display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 10 },
  contactIcon: { fontSize: 14, flexShrink: 0, marginTop: 1 },
  contactText: { color: '#555568', fontSize: 13, fontFamily: 'system-ui' },
  trustBadge: { color: '#444458', fontSize: 12, fontFamily: 'system-ui', padding: '3px 0' },
  bottom: { borderTop: '1px solid rgba(255,255,255,0.04)', padding: isMobile ? '12px 14px' : '16px 32px' },
  bottomInner: { maxWidth: 1280, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  copyright: { color: '#333348', fontSize: 12, fontFamily: 'system-ui' },
  payments: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  payBadge: { background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)', color: '#444458', padding: '3px 8px', borderRadius: 4, fontSize: 10, fontFamily: 'monospace', letterSpacing: 0.5 },
});

export default Footer;
